import { render, staticRenderFns } from "./SecondaryUserDetailsComponent.vue?vue&type=template&id=2a596ca6&scoped=true"
import script from "./SecondaryUserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./SecondaryUserDetailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a596ca6",
  null
  
)

export default component.exports